<template>
  <div>
    <div class="timeline">
      <div class="timeline-step">
        <div :class="['circle', { active: step >= 1, glow: step === 1 }]">📅</div>
        <p>Pre-reunión</p>
      </div>
      <div class="timeline-line" :class="{ active: step >= 2 }"></div>
      <div class="timeline-step">
        <div :class="['circle', { active: step >= 2, glow: step === 2 }]">🗣️</div>
        <p>En-reunión</p>
      </div>
      <div class="timeline-line" :class="{ active: step >= 3 }"></div>
      <div class="timeline-step">
        <div :class="['circle', { active: step >= 3, glow: step === 3 }]">📋</div>
        <p>Post-reunión</p>
      </div>
      <div class="timeline-line" :class="{ active: step >= 4 }"></div>
      <div class="timeline-step">
        <div :class="['circle', { active: step >= 4, glow: step === 4 }]">🎉</div>
        <p>Reunión finalizada</p>
      </div>
    </div>
  </div>
</template>


<script>
export default{
  name: "LifeTimeComponent",
  props: {
    step: {
      type: Number,
      required: true,
    }
  }
}
</script>

<style scoped>
.timeline {
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  /* background-color: blueviolet; */
}

.timeline-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* background-color: red; */
}

.circle {
  width: 40px;
  height: 40px;
  background-color: lightgray; /* color para pasos inactivos */
  color: white;
  font-size: 24px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.circle.active {
  background-color: #00A499; /* color cuando el paso está activo */
}

.timeline-line {
  flex-grow: 1;
  height: 4px;
  background-color: lightgray; /* color para pasos inactivos */
  border-radius: 4px;
  position: relative;
  bottom: 10px;
}

.timeline-line.active {
  background-color: #00A499; /* color cuando el paso está activo */
}

p {
  margin: 0;
  font-size: 14px;
  text-align: center;
}


/* Agrega esto dentro de tu <style scoped> */

@keyframes pulseGlow {
  0% {
    box-shadow: 0 0 0px 0 rgba(0, 164, 153, 0.7);
  }
  50% {
    box-shadow: 0 0 12px 6px rgba(0, 164, 153, 0.5);
  }
  100% {
    box-shadow: 0 0 0px 0 rgba(0, 164, 153, 0.7);
  }
}

.circle.glow {
  animation: pulseGlow 2s infinite;
}

</style>
